import api from '@/helpers/api';

export default {
  // TODO Should be trigerd on initialization and probably added to pusher data under "config data" so it can be synced on the fly
  fetchTemplateMessages({ commit, rootState }, payload) {
    if (!payload.background) {
      commit('TEMPLATE_MESSAGES_LOADED', false);
    }

    const request = api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.businessId}/whatsapp/message-template/list`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          if (payload.businessId === '1f9730b7-bcdc-4547-9d92-4caa70a60643') {
            // FAKE DATA
            // response.data = {
            //   "say_hello": [{ "id": "ef4e5662-c614-46e7-56hr8fa6-227ae6492e8a", "status": "approved", "rejected_reason": null, "keyword": "say_hello1", "tags": ["1"], "button_tags": [], "text": "Hi {{1}}, how are you? How can we help you?", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-09-29 16:14:50", "updated_at": "2020-12-10 16:57:42" }],
            //   "test": [{ "id": "19a1afc4-e440-4193-8ac3-50jjfcabbf0e977", "status": "rejected", "rejected_reason": null, "keyword": "test1", "tags": [], "button_tags": [], "text": "test", "buttons": null, "attachment": null, "language": "hr", "created_at": "2020-09-29 16:04:46", "updated_at": "2020-12-10 16:57:54" }],
            //   "verification_code": [{ "id": "29eaafgjaee51-53aa-4bbc-b594-383c71ce0f8d", "status": "review", "rejected_reason": null, "keyword": "verification_code1", "tags": ["1"], "button_tags": [], "text": "Your Number™ verification code is {{1}}", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-06-19 11:06:17", "updated_at": "2020-08-31 21:54:04" }],
            //   "say_hello_1": [{ "id": "ef4e5662-c61sfgja4-46e7-8fa6-227ae6492e8a", "status": "review", "rejected_reason": null, "keyword": "say_hello2", "tags": ["1"], "button_tags": [], "text": "Hi {{1}}, how are you? How can we help you?", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-09-29 16:14:50", "updated_at": "2020-12-10 16:57:42" }],
            //   "test_1": [{ "id": "19a1afc4-e440-4193-akjrk8acfj3-50cabbf0e977", "status": "review", "rejected_reason": null, "keyword": "test2", "tags": [], "button_tags": [], "text": "test", "buttons": null, "attachment": null, "language": "hr", "created_at": "2020-09-29 16:04:46", "updated_at": "2020-12-10 16:57:54" }],
            //   "verification_code_1": [{ "id": "29eaee51shfk-53aa-4bbc-b594-383c71ce0f8d", "status": "approved", "rejected_reason": null, "keyword": "verification_code2", "tags": ["1"], "button_tags": [], "text": "Your Number™ verification code is {{1}}", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-06-19 11:06:17", "updated_at": "2020-08-31 21:54:04" }],
            //   "say_hello_2": [{ "id": "ef4e5662-c614-46e7-8fssfkka6-227ae6492e8a", "status": "approved", "rejected_reason": null, "keyword": "say_hello3", "tags": ["1"], "button_tags": [], "text": "Hi {{1}}, how are you? How can we help you?", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-09-29 16:14:50", "updated_at": "2020-12-10 16:57:42" }],
            //   "test_2": [{ "id": "19a1afc4-e440-4193-8ac3-50cakgkbbf0e977", "status": "rejected", "rejected_reason": null, "keyword": "test3", "tags": [], "button_tags": [], "text": "test", "buttons": null, "attachment": null, "language": "hr", "created_at": "2020-09-29 16:04:46", "updated_at": "2020-12-10 16:57:54" }],
            //   "verification_code_2": [{ "id": "29eaee51-53aa-4hkgksbbc-b594-383c71ce0f8d", "status": "approved", "rejected_reason": null, "keyword": "verification_code3", "tags": ["1"], "button_tags": [], "text": "Your Number™ verification code is {{1}}", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-06-19 11:06:17", "updated_at": "2020-08-31 21:54:04" }],
            //   "say_hello_3": [{ "id": "ef4e5662-c614-46e7-8fa6tskn-227ae6492e8a", "status": "approved", "rejected_reason": null, "keyword": "say_hello4", "tags": ["1"], "button_tags": [], "text": "Hi {{1}}, how are you? How can we help you?", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-09-29 16:14:50", "updated_at": "2020-12-10 16:57:42" }],
            //   "test_3": [{ "id": "19a1afc4-e440-4193-8ac3-50caipzćibf0e977", "status": "rejected", "rejected_reason": null, "keyword": "test4", "tags": [], "button_tags": [], "text": "test", "buttons": null, "attachment": null, "language": "hr", "created_at": "2020-09-29 16:04:46", "updated_at": "2020-12-10 16:57:54" }],
            //   "verification_code_3": [{ "id": "29eaee51-53aa-4btktsbc-b594-383c71ce0f8d", "status": "approved", "rejected_reason": null, "keyword": "verification_code4", "tags": ["1"], "button_tags": [], "text": "Your Number™ verification code is {{1}}", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-06-19 11:06:17", "updated_at": "2020-08-31 21:54:04" }],
            //   "say_hello_4": [{ "id": "ef4e5662-c614-46e7-8fa6fnaf-227ae6492e8a", "status": "rejected", "rejected_reason": null, "keyword": "say_hello5", "tags": ["1"], "button_tags": [], "text": "Hi {{1}}, how are you? How can we help you?", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-09-29 16:14:50", "updated_at": "2020-12-10 16:57:42" }],
            //   "test_4": [{ "id": "19a1afc4-e440-4193-8ac3-50cavmmxvbbf0e977", "status": "approved", "rejected_reason": null, "keyword": "test5", "tags": [], "button_tags": [], "text": "test", "buttons": null, "attachment": null, "language": "hr", "created_at": "2020-09-29 16:04:46", "updated_at": "2020-12-10 16:57:54" }],
            //   "verification_code_4": [{ "id": "29eaee51-53aa-4gj,bbc-b594-383c71ce0f8d", "status": "approved", "rejected_reason": null, "keyword": "verification_code5", "tags": ["1"], "button_tags": [], "text": "Your Number™ verification code is {{1}}", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-06-19 11:06:17", "updated_at": "2020-08-31 21:54:04" }],
            //   "say_hello_5": [{ "id": "ef4e5662-c614-46e7-8fashm6-227ae6492e8a", "status": "approved", "rejected_reason": null, "keyword": "say_hello6", "tags": ["1"], "button_tags": [], "text": "Hi {{1}}, how are you? How can we help you?", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-09-29 16:14:50", "updated_at": "2020-12-10 16:57:42" }],
            //   "test_5": [{ "id": "19a1afc4-e440-4193-sag8ac3-50cabbf0e977", "status": "approved", "rejected_reason": null, "keyword": "test6", "tags": [], "button_tags": [], "text": "test", "buttons": null, "attachment": null, "language": "hr", "created_at": "2020-09-29 16:04:46", "updated_at": "2020-12-10 16:57:54" }],
            //   "verification_code_5": [{ "id": "29eaesfhe51-53aa-4bbc-b594-383c71ce0f8d", "status": "approved", "rejected_reason": null, "keyword": "verification_code6", "tags": ["1"], "button_tags": [], "text": "Your Number™ verification code is {{1}}", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-06-19 11:06:17", "updated_at": "2020-08-31 21:54:04" }],
            //   "say_hello_6": [{ "id": "ef4e5662-c614-46sfjfse7-8fa6-227ae6492e8a", "status": "rejected", "rejected_reason": null, "keyword": "say_hello7", "tags": ["1"], "button_tags": [], "text": "Hi {{1}}, how are you? How can we help you?", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-09-29 16:14:50", "updated_at": "2020-12-10 16:57:42" }],
            //   "test_6": [{ "id": "19a1afc4-e440-4193-8ac3-5ghk0cabbf0e977", "status": "approved", "rejected_reason": null, "keyword": "test7", "tags": [], "button_tags": [], "text": "test", "buttons": null, "attachment": null, "language": "hr", "created_at": "2020-09-29 16:04:46", "updated_at": "2020-12-10 16:57:54" }],
            //   "verification_code_6": [{ "id": "29eaee51-53aa-4kčgbbc-b594-383c71ce0f8d", "status": "approved", "rejected_reason": null, "keyword": "verification_code7", "tags": ["1"], "button_tags": [], "text": "Your Number™ verification code is {{1}}", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-06-19 11:06:17", "updated_at": "2020-08-31 21:54:04" }],
            //   "say_hello_7": [{ "id": "ef4e5662-c614-46e7-8fa6-227ae6492ehkd8a", "status": "rejected", "rejected_reason": null, "keyword": "say_hello8", "tags": ["1"], "button_tags": [], "text": "Hi {{1}}, how are you? How can we help you?", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-09-29 16:14:50", "updated_at": "2020-12-10 16:57:42" }],
            //   "test_7": [{ "id": "19a1afc4-e440-4193-8ac3-50cabbhčlhčf0e977", "status": "approved", "rejected_reason": null, "keyword": "test8", "tags": [], "button_tags": [], "text": "test", "buttons": null, "attachment": null, "language": "hr", "created_at": "2020-09-29 16:04:46", "updated_at": "2020-12-10 16:57:54" }],
            //   "verification_code_7": [{ "id": "29edgkdaee51-53aa-4bbc-b594-383c71ce0f8d", "status": "rejected", "rejected_reason": null, "keyword": "verification_code8", "tags": ["1"], "button_tags": [], "text": "Your Number™ verification code is {{1}}", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-06-19 11:06:17", "updated_at": "2020-08-31 21:54:04" }],
            //   "say_hello_8": [{ "id": "ef4e5662-c6dgk14-46e7-8hjlflfa6-227ae6492e8a", "status": "approved", "rejected_reason": null, "keyword": "say_hello9", "tags": ["1"], "button_tags": [], "text": "Hi {{1}}, how are you? How can we help you?", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-09-29 16:14:50", "updated_at": "2020-12-10 16:57:42" }],
            //   "test_8": [{ "id": "19a1afc4-e440-4193-8ac3-50cabbf0e9flf77", "status": "approved", "rejected_reason": null, "keyword": "test9", "tags": [], "button_tags": [], "text": "test", "buttons": null, "attachment": null, "language": "hr", "created_at": "2020-09-29 16:04:46", "updated_at": "2020-12-10 16:57:54" }],
            //   "verification_code_8": [{ "id": "29eaee51-53aa-4bbc-dgjb594-383c71ce0f8d", "status": "approved", "rejected_reason": null, "keyword": "verification_code9", "tags": ["1"], "button_tags": [], "text": "Your Number™ verification code is {{1}}", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-06-19 11:06:17", "updated_at": "2020-08-31 21:54:04" }],
            //   "say_hello_9": [{ "id": "ef4e5662-c614-46esfjfs7-8fa6-227ae6492e8a", "status": "approved", "rejected_reason": null, "keyword": "say_hello10", "tags": ["1"], "button_tags": [], "text": "Hi {{1}}, how are you? How can we help you?", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-09-29 16:14:50", "updated_at": "2020-12-10 16:57:42" }],
            //   "test_9": [{ "id": "19a1afc4-e440-4193-8axvbmvmc3-50cabbf0e977", "status": "approved", "rejected_reason": null, "keyword": "test10", "tags": [], "button_tags": [], "text": "test", "buttons": null, "attachment": null, "language": "hr", "created_at": "2020-09-29 16:04:46", "updated_at": "2020-12-10 16:57:54" }],
            //   "verification_code_9": [{ "id": "29eaee51-53aadgkgk-4bbc-b594-383c71ce0f8d", "status": "approved", "rejected_reason": null, "keyword": "verification_code10", "tags": ["1"], "button_tags": [], "text": "Your Number™ verification code is {{1}}", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-06-19 11:06:17", "updated_at": "2020-08-31 21:54:04" }],
            //   "say_hello_10": [{ "id": "ef4e5662-c614-46e7-8fa6-227ae6492e8a", "status": "approved", "rejected_reason": null, "keyword": "say_hello11", "tags": ["1"], "button_tags": [], "text": "Hi {{1}}, how are you? How can we help you?", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-09-29 16:14:50", "updated_at": "2020-12-10 16:57:42" }],
            //   "test_10": [{ "id": "19a1afc4-e440-4193-8ac3-50cabbf0e977", "status": "approved", "rejected_reason": null, "keyword": "test11", "tags": [], "button_tags": [], "text": "test", "buttons": null, "attachment": null, "language": "hr", "created_at": "2020-09-29 16:04:46", "updated_at": "2020-12-10 16:57:54" }],
            //   "verification_code_10": [{ "id": "29eaee51-53aa-4bbc-b594-383c71ce0f8d", "status": "rejected", "rejected_reason": null, "keyword": "verification_code11", "tags": ["1"], "button_tags": [], "text": "Your Number™ verification code is {{1}}", "buttons": null, "attachment": null, "language": "en", "created_at": "2020-06-19 11:06:17", "updated_at": "2020-08-31 21:54:04" }],
            // };
          }
          // TEST TEMPLATE
          // response.data.data.push({
          //   attachment: 'document',
          //   button_tags: [],
          //   buttons: null,
          //   category: "ACCOUNT_UPDATE",
          //   created_at: "2021-09-21 12:45:32",
          //   id: "a10fa47a-5b1b-4f2f-abbb-9582d6910a91",
          //   keyword: "boldddddd",
          //   language: "en",
          //   name: "BBBBBold",
          //   rejected_reason: null,
          //   status: "approved",
          //   tags: ["1", "2"],
          //   text: "~Your~ _Number™_ login *code* for {{1}} is {{2}}.",
          //   updated_at: "2021-09-21 12:45:32",
          // });
          commit('SET_TEMPLATE_MESSAGES', response.data);
          commit('TEMPLATE_MESSAGES_LOADED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
    return request;
  },
  createTemplateMessage({ commit }, payload) {
    commit('TEMPLATE_MESSAGE_CREATED', false);
    api('POST', `/merchants/${payload.merchant_id}/template-messages`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('TEMPLATE_MESSAGE_CREATED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  // updateTemplateMessage({ commit }, payload) {
  //   commit('TEMPLATE_MESSAGE_UPDATED', false);
  //   api('PUT', `/merchants/${payload.merchant_id}/template-messages/${payload.reply_id}`, payload.data)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         commit('TEMPLATE_MESSAGE_UPDATED', true);
  //       }
  //     })
  //     .catch((error) => {
  //       commit('API_ERROR', error.response);
  //     });
  // },
  deleteTemplateMessage({ commit, rootState }, payload) {
    commit('TEMPLATE_MESSAGE_DELETED', false);
    api('DELETE', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchantId}/whatsapp/message-template/${payload.templateId}`, null, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          commit('TEMPLATE_MESSAGE_DELETED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  fetchTemplateAnalytics({ commit }, payload) {
    api('GET', `/merchants/${payload.merchant_id}/template-messages/${payload.keyword}/analytics`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_TEMPLATE_ANALYTICS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  fetchDynamicTags({ commit }, marchantId) {
    api('GET', `/merchants/${marchantId}/template-messages/dynamic-tags`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_DYNAMIC_TAGS', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  fetchSentNotifications({ commit }, payload) {
    commit('SENT_NOTIFICATIONS_LOADED', false);
    api('GET', `/merchants/${payload.merchant_id}/template-messages/sent`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          // Added here so the table gets this _showDetail value and can make the value reactive. It doesn't work otherwise.
          response.data.data.forEach((notification) => {
            // eslint-disable-next-line no-underscore-dangle
            notification._showDetails = false;
          });
          commit('SET_SENT_NOTIFICATIONS', response.data);
          commit('SENT_NOTIFICATIONS_LOADED', true);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },

  sendTemplateMessage({ commit, rootState, dispatch }, payload) {
    // Used for debugging
    // if (payload.data.get('number') === '+385979999999') {
    // commit('TEMPLATE_MESSAGE_SENT', '1234567890');
    // return Promise.resolve();
    // }
    commit('TEMPLATE_MESSAGE_SENT', false);
    commit('BULK_MESSAGES_SENT', false);
    // TODO this endpoint is not ready on backend - test this with send template btn on dashboard
    const request = api('POST', `organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.merchant_id}/whatsapp/send-template-message`, payload.data, null, 'w');
    request.then((response) => {
      if (response.status === 200) {
        // notification can be sent for an individual and as a bulk
        if (response.data.message_reference_id) {
          // commit('TEMPLATE_MESSAGE_SENT', response.data.message_reference_id);
          dispatch('chat/updateMessageRef', {
            sid: response.data.message_reference_id,
            temp_sid: payload.data.get('temp_sid'),
            conversation_id: payload.conversation_id,
          }, { root: true });
        } else {
          commit('BULK_MESSAGES_SENT', response.data.bulk_uid);
        }
      }
    }).catch((error) => {
      commit('TEMPLATE_MESSAGE_FAILED', { conversationId: payload.conversation_id, tempSid: payload.data.get('temp_sid') });
      commit('API_ERROR', error.response);
    });
    return request;
  },
  getCampaignDetails({ commit }, payload) {
    api('GET', `/merchants/${payload.merchant_id}/template-messages/sent/${payload.campaign_id}`, payload.data)
      .then((response) => {
        // Added here so the table gets this _showDetail value and can make the value reactive. It doesn't work otherwise.
        response.data.data.forEach((notification) => {
          // eslint-disable-next-line no-underscore-dangle
          notification._showDetails = false;
        });
        commit('CAMPAIGN_DETAILS', response.data);
        commit('CAMPAIGN_DETAILS_LOADED');
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  getCampaignDetailsResData({ commit }, payload) {
    api('GET', `/merchants/${payload.merchant_id}/template-messages/sent/${payload.campaign_id}/res-data`)
      .then((response) => {
        commit('CAMPAIGN_DETAILS_RES_DATA', response.data);
        commit('CAMPAIGN_DETAILS_RES_DATA_LOADED');
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  resetCampaignDetails({ commit }) {
    commit('CAMPAIGN_DETAILS_RESET');
  },
  /**
   * Retrieves the available tags for notifications and etc.
   * NOTE - params are in the payload
   * @param conversationId Holds conversation id for which the message is received
   * @param messageList Holds all the messages available on the first page.
   */
  // eslint-disable-next-line camelcase
  // TODO - not implementeed on v2 yet. We will refactor it with broadcasting feature.
  loadAvailableNotificationTags({ commit, rootState }, merchantId) {
    // eslint-disable-next-line camelcase
    api('GET', `merchants/${merchantId}/dynamic-tags`)
      // api('GET', `organisation/${rootState.organisation.currentOrganisation.id}/business/${merchantId}/dynamic-tags`, null, null, 'w')
      .then((response) => {
        commit('NOTIFICATION_TAGS', response.data);
        commit('NOTIFICATION_TAGS_LOADED');
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  loadNewTemplateConfig({ commit }) {
    commit('LOADING_NEW_TEMPLATE_CONFIG', true);
    const request = api('GET', '/whatsapp/settings', null, null, 'w');
    request.then((response) => {
      if (response.status === 200) {
        commit('NEW_TEMPLATE_CONFIG', response.data.template);
      }
    })
      .catch((error) => {
        commit('API_ERROR', error.response);
      })
      .finally(() => {
        commit('LOADING_NEW_TEMPLATE_CONFIG', false);
      });
    return request;
  },

  sendBroadcast({ commit, rootState }, payload) {
    const request = api('POST', `/organisation/${rootState.organisation.currentOrganisation.id}/business/${payload.businessId}/contacts/broadcast`, payload.data, null, 'w');
    request
      .then((response) => {
        if (response.status === 200) {
          commit('organisation/SET_BROADCAST_ACTION', { ...response.data, numberId: payload.businessId }, { root: true });
        }
      });
    return request;
  },
};
